import React from "react";
import { useIntl } from "react-intl";
import { JSONTree } from "react-json-tree";
import { base16Themes } from "react-base16-styling";
import { useJSONViewer, GLOBAL_JSON_VIEWER_ID } from "@/hook";
import Button from "@/component/Button";

import { Modal } from ".";


const JSONViewer: React.FC = () => {
    const intl = useIntl();
    const jsonViewer = useJSONViewer();

    return (
        <Modal id={GLOBAL_JSON_VIEWER_ID}
               size="lg"
               title={
                   <div className="modal-header">
                       {jsonViewer.title}
                   </div>
               }
               onClose={() => jsonViewer.close()}
        >
            <div className="modal-description mt-5 overflow-y-auto">
                <JSONTree invertTheme 
                          hideRoot
                          shouldExpandNodeInitially={() => true}
                          theme={base16Themes.default}
                          data={jsonViewer.data}
                />
            </div>

            <div className="modal-btn-group mt-5">
                <Button variant="primary"
                        size="sm"
                        onClick={() => jsonViewer.close()}
                >
                    {intl.formatMessage({ id: "b0001" })}
                </Button>
            </div>
        </Modal>
    );
};

export default JSONViewer;
